import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import parse from 'html-react-parser';
import TermsCondition from "components/safaripackages/view/tabs/policydetails/TermsCondition";

const Policy = ({ safariViewData  }) => {
  const [activeTab, setActiveTab] = useState("tab21");

  const packageData = {
    package_terms_condtition: safariViewData?.package_terms_condtition,
    date_change_policy: safariViewData?.date_change_policy,
    refund_policy: safariViewData?.refund_policy,
  };

  const tabs = [
    { id: "tab21", label: "Terms & Conditions", content: packageData.package_terms_condtition },
    { id: "tab25", label: "Date Change Policy", content: packageData.date_change_policy || "No date change policy provided." },
    { id: "tab26", label: "Refund Policy", content: packageData.refund_policy || "No refund policy provided." },
  ];

  return (
    <div id="policy" role="tabpanel" aria-labelledby="policy-tab" className="mb-3">
      <Row>
        {/* Left Tab Navigation */}
        {/* <Col lg={4} md={4} xl={4} xxl={3} className="package-tab mb-3 mb-lg-0">
          <div className="safri_tour sticky-top border-0">
            <div className="topics_listing px-0 safariChanges">
              <ul id="tabList">
                {tabs.map((tab) => (
                  <li key={tab.id}>
                    <Link
                      className={`tab-items ${activeTab === tab.id ? "active_safri" : ""}`}
                      onClick={() => setActiveTab(tab.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="numparks">{tab.label}</div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Col> */}

        {/* Right Tab Content */}
        <Col lg={12} md={12} xl={12} xxl={12} className="pt-lg-0 pt-2 pb-md-0 pb-3">
        {activeTab === 'tab21' && <div
                    key={tabs[0].id}
                    className={`tab-content_tour"}`}
                    id={tabs[0].id}
                >
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Body>
                                    <div className="itenary-title">
                                        <h6 className="fs-5 pb-2">{tabs[0]?.label}</h6>
                                    </div>
                                    <div className="itenary_text">
                                        {/* {tabs[0]?.content && parse(tabs[0]?.content)} */}
                                        <TermsCondition />

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                }
                {activeTab === 'tab25' && <div
                    key={tabs[1].id}
                    className={`tab-content_tour"}`}
                    id={tabs[1].id}
                >
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Body>
                                    <div className="itenary-title">
                                        <h6 className="fs-5 pb-2">{tabs[1]?.label}</h6>
                                    </div>
                                    <div className="itenary_text">
                                        {tabs[1]?.content && parse(tabs[1]?.content)}

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                }
                {activeTab === 'tab26' && <div
                    key={tabs[2].id}
                    className={`tab-content_tour"}`}
                    id={tabs[2].id}
                >
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Body>
                                    <div className="itenary-title">
                                        <h6 className="fs-5 pb-2">{tabs[2]?.label}</h6>
                                    </div>
                                    <div className="itenary_text">
                                        {tabs[2]?.content && parse(tabs[2]?.content)}

                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                }
        </Col>
      </Row>
    </div>
  );
};

export default Policy;
